import { keyframes } from 'theme'
import { Box } from 'components/elements'

export const ListShimmer = () => {
  return (
    <Box css={{ p: '$space$12 $space$16' }}>
      <Box css={{ ...ShimmerCss, ...ListItemCss }}></Box>
    </Box>
  )
}

export const shimmer = keyframes({
  '0%': {
    backgroundPosition: '-1000px 0px',
  },
  '100%': {
    backgroundPosition: '1000px 0px',
  },
})

export const ShimmerCss = {
  animation: `${shimmer} 3s`,
  animationIterationCount: 'infinite',
  background: 'linear-gradient(to right, #e6e6e6 5%, #cccccc 25%, #e6e6e6 35%)',
  backgroundSize: '1000px 100%',
}

export const ListItemCss = {
  width: 150,
  height: 24,
}
